// extracted by mini-css-extract-plugin
module.exports = {"Markdown":"Markdown_Markdown__Bo6Qp"};